<template src="./CoreAddress.html">
</template>

<script>
import {mask} from "vue-the-mask";
import * as spaApi from "@/spaApi.js"
import tooltips from '@/utilities/tooltips.js'
import * as converters from '@/utilities/countryStateConverters.js'
  import { countryOptions, countryOptionsEPIC, plainPostalCodeCountries } from "@/data/countries.js";

 

export default {
  name: "core-address-component",
  props: {
    name: {
      type: String
    },
    isBP: {
      type: Boolean
    },
    addressData: {
      type: Object,
      default() {
        this.country = 'United States';
        this.line1 = '';
        this.line2 = '';
        this.city = '';
        this.postalcode = '';
        this.stateorprovince = '';
      }
    },
    addressPrefix: {
      type: String
    },
    fireValidation: {
      type: Boolean
    },
    disableControls: {
      type: Boolean
    },
    epicDestination: {
      type: String
    }
  },
    directives: {
        mask
    },
    data() {
        return {
            /* Warning in case of an adjustment here, need to synchronize regex in BIX
             * Or regex per country should be coming from BIX/BUS as best approach
             */
          countryOptions,       // from import
          countryOptionsEPIC,   // from import
          plainPostalCodeCountries, // from import
          selectedCountry: { zipCodeLabel: this.$t("ZipCode"), zipCodeRule: { required: true, regexZip: /^(\d{5}(?:-\d{4})?)$/ }}, //need basic data for proper binding
          currentStates: [], //data holder for states of selected country
          setState: null,
          clearZipState: false
        };
    },
    computed: {
      showPlainPostalInput() {
        return plainPostalCodeCountries.includes(this.addressData.address1Country);
      },
      translatedCountryOptions() {
        return this.countryOptions.map(opt => ({
          ...opt,
          name: this.$t(opt.name), // translates display name
          zipCodeLabel: this.$t(opt.zipCodeLabel) // translates ZIP/postal label
        }));
      },
      translatedCountryOptionsEPIC() {
        return this.countryOptionsEPIC.map(opt => ({
          ...opt,
          name: this.$t(opt.name),
          zipCodeLabel: this.$t(opt.zipCodeLabel)
        }));
      }
    },
    watch: {
      'addressData.address1Country': function (newVal, oldVal) {
            this.selectedCountry = this.getCountry(newVal); //needed only to init mask before v-on:change="countryChanage(...)" will wipe zip code
        },
      'addressData': function (newVal, oldVal) {
        this.setStates(newVal.address1Country, false);
        },
    },
    mounted() {
        this.init();
    },
    methods: {
      init() {
        this.addressData.originalCore_address1_country = this.addressData.address1Country;
        this.addressData.originalCore_address1_stateorprovince = this.addressData.address1StateOrProvince;

        if(this.isBP)
          this.translateValidValuesToBP();
        else
          this.translateValidValuesToEPIC();
      },
      stateToolTip() {
        return tooltips.originalCoreToolTip(this.addressData.originalCore_address1_stateorprovince);
      },
      countryToolTip() {
        return tooltips.originalCoreToolTip(this.addressData.originalCore_address1_country);
      },
      setStates(countryId, clearZipState) {

        this.clearZipState = clearZipState;
        let country = this.getCountry(countryId);
        this.selectedCountry = country;
        if(this.isBP)
          spaApi.getCountryStatesBP(country.description, this.setStatesCallback);
        else
          spaApi.getCountryStatesEPIC(country.id, this.epicDestination, this.setStatesCallback);
      },
      setStatesCallback(states) {
        if (!states) {
          return;
        }
        this.currentStates = states;
        this.clearOrSetDefaults();

        if (this.setState) {
          let stateId;
          if (this.isBP) {
            if (isNaN(this.setState))
              stateId = this.currentStates.find(x => x.name == this.setState).id;
            else
              stateId = this.setState;
          }
          else
            stateId = this.currentStates.find(x => x.description == this.setState).code;

          this.addressData.address1StateOrProvince = stateId;
          this.setState = null;
        }
      },
      isEpicCoreCountries(countryId) {
        return ['USA', 'CAN' ].includes(countryId);
      },
      countryChange(countryId) {
        this.setStates(countryId, true);
      },
      getCountry(countryId) {
        if(this.isBP)
            return this.countryOptions.find(x => x.id == countryId);
        else
          return this.countryOptionsEPIC.find(x => x.id == countryId);
        },
        clearOrSetDefaults(){
          if (this.currentStates.length == 1) {
            this.addressData.address1StateOrProvince = this.currentStates[0].id;
          }
          else if (this.clearZipState) {
            this.addressData.address1StateOrProvince = null;
          }

          if (this.clearZipState) {
              this.addressData.address1PostalCode = null;
          }
      },
      translateValidValuesToBP() {
        var countryId;

        if (!this.addressData.address1Country) {
          this.addressData.address1Country = this.epicDestination;
        }

        if (isNaN(this.addressData.address1Country)) {
          var country = converters.convertBPCountry(this.addressData.address1Country);
          const matchedCountry = this.countryOptions.find(x => x.description == country);
          if (matchedCountry)
            countryId = matchedCountry.id;
        }
        else if (this.countryOptions.find(x => x.id == this.addressData.address1Country))
          countryId = this.addressData.address1Country;

        if (countryId)
          this.addressData.address1Country = countryId
        else {
          this.addressData.address1Country = 1; // Default to USA
          countryId = 1;
        }

        this.selectedCountry = this.getCountry(this.addressData.address1Country);

        if (isNaN(this.addressData.address1StateOrProvince)) {
          this.setState = converters.convertStateToFullName(this.addressData.address1StateOrProvince);
        }
        else
          this.setState = this.addressData.address1StateOrProvince;

        this.setStates(countryId, false);

      },
      translateValidValuesToEPIC() {
        if (!this.addressData.address1Country) {
          this.addressData.address1Country = this.epicDestination;
        }

        const country = converters.convertEPICCountry(this.addressData.address1Country);

        var countryId = this.countryOptionsEPIC.find(x => x.id == country).id;
        if (countryId)
          this.addressData.address1Country = countryId
        
        this.selectedCountry = this.getCountry(this.addressData.address1Country);
        if (!countryId)
          countryId = this.selectedCountry.id

        this.setState = converters.convertStateToFullName(this.addressData.address1StateOrProvince);
        this.setStates(countryId, false);

      }
    }
};
</script>
